import styled from "styled-components";

export const Heading = styled.h1`
  text-align: center;
  color: green;
`;

export const Content = styled.div`
  overflowy: scroll;
  height: 2500px;
`;

export const Button = styled.div`
  position: fixed;
  bottom: 70px;
  height: 20px;
  font-size: 3rem;
  z-index: 1000;
  cursor: pointer;
  color: green;
  right: 20px;
`;
